import { type FC, type ReactNode } from 'react'
import { FormHelperText, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import { getMeaIcon } from '@DS/components/icons/meaIcons'

import * as styles from './styles'

const AlertIcon = getMeaIcon('alert')

type FormErrorHelperProps = {
  dataTest?: string
  error?: boolean
  helperText: ReactNode
  id?: string
}

const FormErrorHelper: FC<FormErrorHelperProps> = ({ error, dataTest, id, helperText }) => {
  const theme = useTheme()

  return (
    <FormHelperText error={error} id={id} data-test={dataTest} css={styles.helperTextMessage(theme)}>
      <AlertIcon css={styles.helperTextAlertIcon(theme)} />
      <Typography variant="subtitle1" component="span">
        {helperText}
      </Typography>
    </FormHelperText>
  )
}

export default FormErrorHelper
